<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>

    <div v-else>
      <v-stepper v-model="currentStep" alt-labels flat non-linear class="no-transition">
        <v-stepper-header>
          <v-stepper-step step="1" :color="stepsError.step1 ? 'error': 'primary' " />
          <v-divider />
          <v-stepper-step step="2" :color="stepsError.step2 ? 'error': 'primary' " />
          <v-divider />
          <v-stepper-step step="3" :color="stepsError.step3 ? 'error': 'primary' " />
          <v-divider />
          <v-stepper-step step="4" :color="stepsError.step4 ? 'error': 'primary' " />
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <step1
              :artwork="artwowrk"
              @next="nextStep"
              @created="(e) => artwowrk = e "
              @error="onStepError"
            />
          </v-stepper-content>

          <v-stepper-content step="2">
            <step2
              :artwork="artwowrk"
              @next="nextStep"
              @prev="prevStep"
              @created="(e) => artwowrk = e "
              @error="onStepError"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <step3
              :artwork="artwowrk"
              @next="nextStep"
              @prev="prevStep"
              @created="(e) => artwowrk = e "
              @error="onStepError"
            />
          </v-stepper-content>

          <v-stepper-content step="4">
            <step4
              :artwork="artwowrk"
              @prev="prevStep"
              @created="(e) => artwowrk = e "
              @error="onStepError"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  name: 'ProfileArtworkEditPage',
  props: ["artworkId"],

  components: {
    Step1: () => import("./Step1"),
    Step2: () => import("./Step2"),
    Step3: () => import("./Step3"),
    Step4: () => import("./Step4")
  },

  data() {
    return {
      currentStep: 0,
      artwowrk: null,
      loading: false,
      stepsError: {
        step1: false,
        step2: false,
        step3: false,
        step4: false
      }
    };
  },

  created() {
    if (this.artworkId) this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await handler.handle(async () => {
        this.artwowrk = await artworksRepo.profileArtwork(this.artworkId);
      });
      this.loading = false;
    },

    nextStep(stepName) {
      if (this.currentStep < 4) {
        this.currentStep++;
        this.$app.toast(this.$t("COMMON.SAVED"));
        window.scrollTo(0, 0);

        if (stepName) {
          this.stepsError[stepName] = false;
        }
      }
    },

    prevStep() {
      if (this.currentStep !== 0) {
        this.currentStep--;
      }
    },

    onStepError(stepName) {
      this.stepsError[stepName] = true;
      console.log("OnStepError", stepName);
    }
  }
};
</script>

<style lang="scss">
.no-transition .v-stepper__content {
  transition: none;
}
</style>
